import React from 'react';
import './NavBar.css';
import { Link } from 'react-scroll';


import youtube from "../../assets/socialmedia/youtube.png";
import spotify from "../../assets/socialmedia/spotify.png";
import instagram from "../../assets/socialmedia/instagram.png";
import applemusic from "../../assets/socialmedia/applemusic.png";
import tidal from "../../assets/socialmedia/tidal.png";
import bandcamp from "../../assets/socialmedia/bandcamp.png";




export const NavBar = () => {
    return (
        <nav className="nav-bar-container">

            <div className='nav-link-container'>
                <div className='nav-link-container'>
                    <a className='nav-bar-link nav-icon' href="https://www.instagram.com/mondwild/" rel="noreferrer"
                        target="_blank"><img className='instagram' src={instagram} alt="instagram" /></a>

                    <a className='nav-bar-link nav-icon' href="https://open.spotify.com/artist/6s96d678Hgy10yUb32I0GT" rel="noreferrer"
                        target="_blank"><img className='spotify' src={spotify} alt="spotify" /></a>
                    <a className='nav-bar-link nav-icon' href="https://www.youtube.com/@mondwild" rel="noreferrer"
                        target="_blank"><img className='youtube' src={youtube} alt="youtube" /></a>
                    <a className='nav-bar-link nav-icon' href="https://music.apple.com/de/artist/mondwild/1870810851" rel="noreferrer"
                        target="_blank"><img className='applemusic' src={applemusic}
                            alt="applemusic" /></a>
                    <a className='nav-bar-link nav-icon' href="https://tidal.com/artist/73373166" rel="noreferrer"
                        target="_blank"><img className='tidal' src={tidal}
                            alt="tidal" /></a>
                    <a className='nav-bar-link nav-icon' href="https://mondwild.bandcamp.com/" rel="noreferrer"
                        target="_blank"><img className='bandcamp' src={bandcamp}
                            alt="bandcamp" /></a>





                </div>
            </div>

        </nav>
    )
}